export default __webpack_public_path__ + "static/media/typeL_high_lamp.c5fb8421.png";